import React from "react";
import LemonWireLogo from "./LemonWireLogo";
import { Download, Mail } from "lucide-react";

export default function SiteHeader({ onTellFriend, onGetPro }) {
  return (
    <div
      data-testid="site-header"
      className="relative overflow-hidden bevel-out"
      style={{
        background: "linear-gradient(180deg, #4DBA2C 0%, #7DDE5C 35%, #B6FF00 55%, #FFF176 75%, #FFEB3B 100%)",
        height: 150,
      }}
    >
      {/* Subtle checker pattern */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-10 pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(0deg, transparent 0 4px, rgba(0,0,0,0.5) 4px 5px), repeating-linear-gradient(90deg, transparent 0 4px, rgba(0,0,0,0.5) 4px 5px)",
        }}
      />
      {/* XP Bliss-style hills at bottom */}
      <div
        aria-hidden
        className="absolute bottom-0 left-0 right-0 h-12 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 40% 120% at 18% 120%, #1F6F1F 0%, transparent 60%), radial-gradient(ellipse 50% 120% at 80% 110%, #0F4F0F 0%, transparent 55%)",
        }}
      />

      <div className="relative z-10 h-full px-5 flex items-center">
        <LemonWireLogo size={64} />

        <div className="ml-auto flex flex-col items-end gap-2">
          <div className="flex items-center gap-2">
            <button
              data-testid="header-download-pro"
              onClick={onGetPro}
              className="bevel-btn-green px-4 py-1.5 text-[13px] font-bold flex items-center gap-2"
            >
              <Download size={14} />
              Get LemonWire Pro!
            </button>
            <button
              data-testid="header-tell-friend"
              onClick={onTellFriend}
              className="bevel-btn px-3 py-1.5 text-[12px] flex items-center gap-1.5"
            >
              <Mail size={12} />
              Tell a Friend
            </button>
          </div>

          <div className="flex items-center gap-2">
            <div className="starburst text-[10px]" style={{ width: 54, height: 54 }}>
              <div className="flex flex-col items-center leading-tight">
                <span style={{ fontSize: 9 }}>100%</span>
                <span style={{ fontSize: 11 }}>VIRUS</span>
                <span style={{ fontSize: 9 }}>FREE!</span>
              </div>
            </div>
            <div
              className="starburst text-[10px]"
              style={{ background: "#1F8020", width: 54, height: 54, transform: "rotate(8deg)" }}
            >
              <div className="flex flex-col items-center leading-tight">
                <span style={{ fontSize: 11 }}>FREE</span>
                <span style={{ fontSize: 9 }}>to DL</span>
              </div>
            </div>
            <div
              className="starburst text-[10px]"
              style={{ background: "#0053e1", width: 54, height: 54, transform: "rotate(-6deg)" }}
            >
              <div className="flex flex-col items-center leading-tight">
                <span style={{ fontSize: 9 }}>OVER</span>
                <span style={{ fontSize: 12 }}>4.9M</span>
                <span style={{ fontSize: 8 }}>FILES</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
